import gql from 'graphql-tag';
import {client} from "./client";
import {RequestContactByPocId} from "../../schema/RequestContactByPocId";
import {Contact, Query} from "../../types";

export async function requestContactByPocId (pocid: string):
    Promise<Contact|undefined> {
    try {
        const result: {data: Query} = await client.query({
            query: gql`${RequestContactByPocId}`,
            variables: {
                pocid,
            }
        });
        console.log(result);
        return result.data.contactByPocid!;
    } catch (e) {
        return undefined;
    }
}

